

import React from 'react';
import './LoggedOut.css'
class LoggedOut extends React.Component {

    render() {
        return (
            <div className="mainLogoutWrapper">
                <div id="wrapper" className="animated zoomIn">
                    <div className="logout_heading_wrapper">
                        <div className="underline">Logged Out!</div>
                    </div>
                    <div className="logutMessageText">
                        You have logged out from MyGame.
                  </div>
                </div>
            </div>
        )
    }
}

export default LoggedOut


/** WEBPACK FOOTER **
 ** ./src/components/LoggedOut.js
 **/